function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1574 3.86377L11.512 11.9104L13.8214 13.2438L18.4667 5.1971C24.0267 8.8931 26.8747 14.6371 24.5467 18.6664C22.0667 22.9624 14.9614 23.1398 8.6667 19.5064C2.37203 15.8691 -1.02663 9.62777 1.45337 5.3331C3.78003 1.30244 10.1774 0.897103 16.1574 3.86377ZM18.1787 0.36377L20.488 1.6971L18.488 5.1611L16.1787 3.82777L18.1787 0.36377ZM5.97603 24.6664H19.6667V27.3331H3.68937C3.45136 27.3378 3.21647 27.2784 3.00933 27.1611C2.80218 27.0438 2.63041 26.873 2.51203 26.6664C2.39566 26.4635 2.33442 26.2337 2.33442 25.9998C2.33442 25.7659 2.39566 25.536 2.51203 25.3331L5.51203 20.1371L7.82137 21.4704L5.97603 24.6664Z"
});

function SvgSatelite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelite);
export default __webpack_public_path__ + "static/media/satelite.e3bf9c30.svg";
export { ForwardRef as ReactComponent };